// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a492ffeb","499":"f49b1e25","755":"ed5a4cb9"}[chunkId] + ".chunk.js";
};